<!--
  Component: VizLegendDivs

  This component creates legend items within divs of main values and comp values
  added through the metadata.

  Notes:
  - Number of legend groups is determined automatically based on length of legend text
  - Number of lines in 'legend-items-column' for each legend group is determined automatically

  Props:
  - legend (optional) - in format used by LegendObjectMixin
  - mainCssClass - (optional) css class to add to main bar / legend items
  - compCssClasses - (optional) array of css class strings to add to comp bars
      and legend items.
  - ariaLabelText - (optional) uses label as text for whole component if present, otherwise defaults to regular behavior of reading all contents
-->

<template>
  <!--
  Use aria-label because title changes aren't capture automatically by NVDA
  Not using aria-labelledby because then we would need unique id passed in from outside

  Another alternative is to use aria-hidden='true', with sr-only span:
  https://css-tricks.com/gotchas-getting-inline-svg-production-part-ii/#article-header-id-9
   -->
  <div
    v-if="hasLegend"
    class="viz-legend"
    :role="ariaLabelText !== undefined && ariaLabelText !== null ? 'img' : undefined"
    :aria-label="ariaLabelText"
  >
    <template
      v-for="(dataGroup, i) in [legendObject.main, legendObject.comp]"
    >
      <div
        v-for="(typeGroup, j) in dataGroup"
        :key="`legend-item-${i}-${j}`"
        class="legend-group"
      >
        <div
          class="legend-items-column"
        >
          <div
            :class="['bar', i === 0 ? 'main' : 'comp', i === 0 ? mainCssClass : compCssClasses[j]]"
          />
        </div>
        <div class="legend-items-column">
          <div v-for="(text, k) in typeGroup"
            :key="`legend-text-${i}-${j}-${k}`"
          >
            {{text}}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import { LegendObjectMixin } from '@/mixin'

@Component({
  props: {
    ariaLabelText: String,
    mainCssClass: {
      type: String,
      default: ''
    },
    compCssClasses: {
      type: Array,
      default: () => []
    }
  }
})
export default class VizLegendDivs extends mixins(LegendObjectMixin) {
  /* Legend */
}
</script>

<!-- These are base-version formatting rules meant to be overridden, so keep them unscoped -->
<style lang="scss">
.viz-legend {
  padding: 5px 10px 5px 16px;
  .legend-group {
    display: flex;
    .legend-items-column {
      display: inline-block;
      line-height: 18px;
      &:nth-child(1) {
        display: flex;
        height: 13px;
        margin: 2px 9px 0 0;
      }
      .bar {
        width: 0;
        height: 0.867em;
        margin: auto 0;
        border-left-width: 28px;
        border-left-style: solid;
      }
      .bar.comp {
        border-left-color: #949494;
      }
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/VizLegendDivs.vue